var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    [
      _vm._l(_vm.value, function(comment, ci) {
        return [
          comment.parent == null
            ? _c("li", [
                _c(
                  "div",
                  {
                    staticClass: "type",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.openReply(ci)
                      }
                    }
                  },
                  [_vm._v("Reply")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "author" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        comment.author.firstname + " " + comment.author.lastname
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "auth-img" }, [
                  _c("img", {
                    attrs: { src: _vm.photoLink(comment.author.media) }
                  })
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "comment-text",
                  domProps: {
                    innerHTML: _vm._s(_vm.escapeText(comment.content))
                  }
                }),
                _vm._v(" "),
                _c("time", [
                  _vm._v(
                    _vm._s(
                      _vm.formatDate(
                        comment.created,
                        "MMM Do, YYYY [at] h:mm a"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c("a", {
                  staticClass: "remove",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.remove(ci)
                    }
                  }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.value, function(comment2, ci2) {
            return comment2.parent == comment.id
              ? _c("li", { staticClass: "reply" }, [
                  _c("div", { staticClass: "author" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          comment2.author.firstname +
                            " " +
                            comment2.author.lastname
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "auth-img" }, [
                    _c("img", {
                      attrs: { src: _vm.photoLink(comment2.author.media) }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "comment-text",
                    domProps: {
                      innerHTML: _vm._s(_vm.escapeText(comment2.content))
                    }
                  }),
                  _vm._v(" "),
                  _c("time", [
                    _vm._v(
                      _vm._s(
                        _vm.formatDate(
                          comment2.created,
                          "MMM Do, YYYY [at] h:mm a"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("a", {
                    staticClass: "remove",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.remove(ci2)
                      }
                    }
                  })
                ])
              : _vm._e()
          }),
          _vm._v(" "),
          _vm.replyId == comment.id
            ? _c("li", { staticClass: "form reply" }, [
                _c("div", { staticClass: "type" }, [_vm._v("Leave a Reply")]),
                _vm._v(" "),
                _c("div", { staticClass: "auth-img" }, [
                  _c("img", {
                    attrs: { src: _vm.photoLink(_vm.currentUser.media) }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.submitReply($event)
                      }
                    }
                  },
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.replyComment,
                          expression: "replyComment"
                        }
                      ],
                      ref: "replyBox",
                      refInFor: true,
                      domProps: { value: _vm.replyComment },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.replyComment = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("button", [_vm._v("Send")])
                  ]
                )
              ])
            : _vm._e()
        ]
      }),
      _vm._v(" "),
      _c("li", { staticClass: "form" }, [
        _c("div", { staticClass: "type" }, [_vm._v("Leave a Comment")]),
        _vm._v(" "),
        _c("div", { staticClass: "auth-img" }, [
          _c("img", { attrs: { src: _vm.photoLink(_vm.currentUser.media) } })
        ]),
        _vm._v(" "),
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.submitComment($event)
              }
            }
          },
          [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newComment,
                  expression: "newComment"
                }
              ],
              ref: "commentBox",
              domProps: { value: _vm.newComment },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.newComment = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("button", [_vm._v("Send")])
          ]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }